import { useAuth } from "@clerk/nextjs";
import { Popover } from "@headlessui/react";
import { AnimatePresence, motion } from "framer-motion";
import Link from "next/link";
import { useMemo } from "react";

import { useCertification } from "~/hooks";

const CertificationWorkshopPopover = () => {
	const { certification } = useCertification();
	const { isSignedIn } = useAuth();

	const earnedCoreCreditsWithWorkshop = useMemo(
		() =>
			(certification.earnedTotalCredits || 0) -
			(certification.earnedWorkshopCredits || 0),
		[certification.earnedTotalCredits, certification.earnedWorkshopCredits],
	);

	if (
		!(
			certification.workshopCreditMode === "Certification" &&
			certification.linkedWorkshop
		)
	)
		return null;

	return (
		<Popover className="relative">
			{({ open }) => (
				<>
					<Popover.Button className="flex w-full flex-col gap-2 rounded-2xl bg-gradient-to-br from-orange-50 to-indigo-50 px-5 py-3 shadow-inner hover:brightness-95 dark:from-orange-300/20 dark:to-indigo-300/20 dark:hover:brightness-125">
						<div className="flex w-full justify-between gap-2">
							<span className="font-medium"> Online Courses:</span>{" "}
							{isSignedIn ? earnedCoreCreditsWithWorkshop : null}{" "}
							{isSignedIn && "/"}{" "}
							{certification.totalCredits -
								certification.linkedWorkshop!.credits}{" "}
							Credits
						</div>

						<div className="flex w-full justify-between gap-2">
							<span className="font-medium">Live Workshop:</span>{" "}
							{isSignedIn && (certification.earnedWorkshopCredits || 0)}{" "}
							{isSignedIn ? "/" : null} {certification.linkedWorkshop!.credits}{" "}
							Credits
						</div>
					</Popover.Button>

					<AnimatePresence>
						{open && (
							<Popover.Panel
								static
								as={motion.div}
								initial={{ opacity: 0, scale: 0.9 }}
								animate={{
									opacity: 1,
									scale: 1,
									transition: { duration: 0.3 },
								}}
								exit={{ opacity: 0, scale: 0.9, transition: { duration: 0.2 } }}
								className="absolute -top-2 z-20 flex w-full flex-col gap-0.5 rounded-2xl border bg-white px-4 py-3 shadow-lg dark:bg-slate-700 dark:shadow-black/10"
							>
								<h4 className="-mt-0.5 font-medium text-lg">
									IMT-C and IMT Credit Breakdown:
								</h4>
								<p>
									The Integrated Manual Therapy (IMT) certification consists of
									80 credits. If the 64 online credits are earned before
									completing a live workshop the Integrated Manual
									Therapist-Candidate (IMT-C) certificate will be awarded. You
									can find the list of available workshops on the{" "}
									<Link
										href="/live-events/workshops"
										target="_blank"
										className="font-medium text-sky-700 hover:underline dark:text-sky-300"
									>
										{" "}
										Workshop Page.{" "}
									</Link>
								</p>
							</Popover.Panel>
						)}
					</AnimatePresence>
				</>
			)}
		</Popover>
	);
};

export default CertificationWorkshopPopover;
